import { Pipe, PipeTransform } from '@angular/core';
import { IDatePlace } from '../models/location.model';

@Pipe({ name: 'uniquePlaces',pure:false })
export class UniquePlacesPipe implements PipeTransform {
  constructor(){

  }
  transform(datesPlaces: IDatePlace[]) {
    const places = datesPlaces.map(item => item.geocoding.address.city);
    const uniquePlaces = [...new Set(places)];
    return uniquePlaces;
  }
}